import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const BaseParagraph = styled.p<TPBaseProps>`
    margin: 0;
    color: ${({ $color }) => $color ? $color : 'inherit'};
    ${({ $withIndent }) => $withIndent ? 'margin-bottom: 24px;' : ''}
`;

export type TPBaseProps = {
    $withIndent?: boolean,
    $color?: COLORS,
}

export type TPSmallerProps = {
    $smaller?: boolean,
} & TPBaseProps;

type TActionDesktopFont = Extract<
    keyof typeof FONTS,
    | 'Medium'
    | 'MediumS'
    | 'MediumXS'
    | 'MediumXXS'
    | 'MediumXXXS'
>;

type TActionDesktopStylesProps = {
    $mobile: TActionDesktopFont,
    $desktop: TActionDesktopFont,
    $smaller?: boolean,
};

export const createActionDesktopElementStyles = ({ $mobile, $desktop, $smaller }: TActionDesktopStylesProps) => `
    b, strong {
        ${FONTS[$mobile]};
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        b, strong {
            ${FONTS[$smaller ? $mobile : $desktop]};
        }
    }
`;

export const Paragraph1 = styled(BaseParagraph)`
    ${FONTS.L};

    b {
        ${FONTS.Medium};
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${({ $withIndent = false }) => $withIndent ? 'margin-bottom: 56px;' : ''}
        ${FONTS.XXL};
    }
`;

export const Paragraph2 = styled(BaseParagraph)<TPSmallerProps>`
    ${FONTS.M};

    b {
        ${FONTS.Medium};
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${({ $smaller = false }) => $smaller ? FONTS.L : FONTS.XL};
    }
`;

export const Paragraph3 = styled(BaseParagraph)`
    ${FONTS.S};
    ${createActionDesktopElementStyles({ $mobile: 'MediumS', $desktop: 'Medium' })};

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${FONTS.M};
    }
`;

export const Paragraph4 = styled(BaseParagraph)<TPSmallerProps>`
    ${FONTS.XS};
    ${({ $smaller = false }) => createActionDesktopElementStyles({ $mobile: 'MediumXS', $desktop: 'MediumS', $smaller })};

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${({ $smaller = false }) => $smaller ? FONTS.XS : FONTS.S};
    }
`;

export const Paragraph5 = styled(BaseParagraph)`
    ${FONTS.XXS};

    b {
        ${FONTS.MediumXXS};
    }
`;

export const StoryParagraph = styled(BaseParagraph)`
    ${FONTS.StoriesS};

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${FONTS.Stories}
    }
`;
